import loanTypeUserDefinedRates from "@/api/credit-operation/loan-type-user-defined-rates";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    loanTypes: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_LOAN_TYPES(state, data) {
        state.loanTypes = data;
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return loanTypeUserDefinedRates.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return loanTypeUserDefinedRates.store(data);
    },
    update(context, { id, data }) {
        return loanTypeUserDefinedRates.update(id, data);
    },
    destroy(context, id) {
        return loanTypeUserDefinedRates.destroy(id);
    },
    async getLoanType(context, attributes = {}) {
        let response = await loanTypeUserDefinedRates.loanType({ params: attributes });
        context.commit("SET_LOAN_TYPES", response.data);
    }
};
